// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ArrowAltRightUpLeft(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ArrowAltRightUpLeft" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M9 1.5L1.5 7.5L9 13.5V9.75H18V18H9V22.5H18.75C20.8211 22.5 22.5 20.8211 22.5 18.75V9C22.5 6.92893 20.8211 5.25 18.75 5.25H9V1.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ArrowAltRightUpLeft.js.map